import { useTranslation } from "react-i18next";

import { useBlogSelectors } from "../../../../../store/blog/blog.selectors";

import { getLangParams, getRandomElements } from "../../../../../utils/helpers";

import { useGetOtherBlogArticle } from "../../../../../hooks";

import { ArticleSubHead } from "../ArticleSubHead/ArticleSubHead";
import OtherArticleCardItem from "./components/OtherArticleCardItem";

import {
  OtherArticleList,
  StyledLink,
  WrapperOne,
  WrapperTwo,
} from "./OtherArticles.styled";

export const OtherArticles = () => {
  const { t } = useTranslation();
  const lang = getLangParams();
  useGetOtherBlogArticle();

  const { blogData } = useBlogSelectors();

  const countElements = 3;
  const articles = getRandomElements(blogData.content, countElements);

  return (
    <div>
      <WrapperOne>
        <ArticleSubHead title={t("blog.otherArticles")} />
        <StyledLink to={`/${lang}blog/`}>{t("global.viewAll")}</StyledLink>
      </WrapperOne>

      <WrapperTwo>
        <OtherArticleList>
          {articles?.length > 0 &&
            articles.map(({ id, title, description, slug }) => (
              <OtherArticleCardItem
                key={id}
                link={slug}
                title={title}
                description={description}
                lang={lang}
              />
            ))}
        </OtherArticleList>
      </WrapperTwo>
    </div>
  );
};
